/*
 * Copyright (c) 2021 brightlamp
 */

import { axiosInit } from './axiosSetup';
import { v4 as uuidv4 } from 'uuid';
const clonedeep = require('lodash.clonedeep');

export default {
    namespaced: true,
    state:
    {
        totalTestRequests: 0,
        testRequests: [],
        testRequestToMutate: null,
        createForAllGroupMembers: false
    },
    mutations:
    {
        CLEAR_TEST_REQUESTS(state)
        {
            state.testRequests = []
        },
        SET_TEST_REQUESTS: (state, payload) =>
        {
            state.testRequests = payload;
            state.totalTestRequests = payload.length
        },
        SET_TOTAL_TEST_REQUESTS: (state, payload) =>
        {
            state.totalTestRequests = payload
        },
        SET_CREATE_FOR_ALL_GROUP_MEMBERS: (state, payload) =>
        {
            state.createForAllGroupMembers = payload
        },
        INIT_TEST_REQUEST: (state, payload) =>
        {
            state.testRequestToMutate =
            {
                testToken: uuidv4(),
                mrn: '',
                name: '',
                rightEye: false,
                leftEye: false,
                baseline: false,
                testTag: '',
                tokenExpireDate: new Date(),
                emailSubject: payload.telehealthEmailSubject
            }
        },
        UPDATE_MUTATED_TEST_REQUEST: (state, payload) =>
        {
            state.testRequestToMutate = clonedeep(payload)
        },
        INSERT_TEST_REQUEST: (state, payload) =>
        {
            state.testRequests = state.testRequests.filter(testRequest => testRequest.testToken !== payload.testToken)
            state.testRequests.push(payload);
            state.totalTestRequests++
        },
        DELETE_TEST_REQUEST: (state, payload) =>
        {
            state.testRequests = state.testRequests.filter(testRequest => testRequest.testToken !== payload)
            state.totalTestRequests--
        }
    },
    actions:
    {
        GET_TEST_REQUESTS: async (context, payload) =>
        {
            const { sortBy, sortDesc, page, itemsPerPage } = payload.pagination;
            const axios = await axiosInit();
            const response = await axios.get('/telehealth/test-request',
            {
                params:
                {
                    userOnly: payload.userOnly,
                    searchValue: payload.searchValue,
                    sortValue: sortBy.toString(),
                    sortOrder: sortDesc.map(value => value ? -1 : 1).toString(),
                    page: page,
                    limit: -1 === itemsPerPage ? 2147483647 : itemsPerPage
                }
            });
            getTestRequests(context, response);
            context.commit('SET_TOTAL_TEST_REQUESTS', response['headers']['max-count'] * 1)
        },
        SEND_TEST_REQUEST: async (context, payload) =>
        {
            const axios = await axiosInit();
            const request = {testRequest: payload.data};
            // If we should pass the group ID to the server
            if (payload.createForAllGroupMembers)
            {
                request.groupId = payload.groupId
            }
            const response = await axios.post('/telehealth/test-request', request);
            context.commit('INSERT_TEST_REQUEST', getTestRequest(response['data']))
        },
        DELETE_TEST_REQUEST: async (context, payload) =>
        {
            const axios = await axiosInit();
            await axios.delete(`/telehealth/test-request/${payload.testToken}`);
            context.commit('DELETE_TEST_REQUEST', payload.testToken)
        },
        SEND_TEST_REQUEST_INVITES: async (context, payload) =>
        {
            const axios = await axiosInit();
            await axios.post(`/telehealth/test-request/invite/${payload.mrn}`)
        }
    }
}

function getTestRequests(context, response)
{
    const testRequests = response.data;
    for (let testRequest of testRequests)
    {
        testRequest = getTestRequest(testRequest)
    }
    context.commit('SET_TEST_REQUESTS', testRequests)
}

function getTestRequest(testRequest)
{
    testRequest.displayName = testRequest.displayName != null ? testRequest.displayName : 'N/A';
    testRequest.name = testRequest.name ? testRequest.name : 'N/A';
    let date = new Date(testRequest.requestDate);
    testRequest.requestDate = date.toLocaleString();

    testRequest.allowEdit = true;
    if (testRequest.rightEye && testRequest.leftEye)
    {
        testRequest.eyeTested = 'Both';
    }
    else if (testRequest.rightEye)
    {
        testRequest.eyeTested = 'Right';
    }
    else
    {
        testRequest.eyeTested = 'Left';
    }
    testRequest.baselineDisplay = testRequest.baseline ? 'Yes' : 'No';
    return testRequest
}